import { useEffect, useState } from 'react';
import { t } from '@lingui/core/macro';
import clsx from 'clsx';
import { useWhatsNew } from 'components/WhatsNew/useWhatsNew/useWhatsNew';
import useWindowDimensions from 'hooks/useWindowDimensions';
import { BREAK_M } from 'utils/breakpoints';
import { getCookie, setCookie } from 'utils/cookieHelper';
import { PATH_NAMES } from 'utils/routes/pathNames';
import navigationStyles from '../Navigation.module.css';
import { NavItemLink } from '../NavItemLink/NavItemLink';
import { Indicator } from './Indicator/Indicator';
import { Popup } from './Popup/Popup';
import styles from './WhatsNewButton.module.css';

type TProps = {
  introducerId: string;
  disabled?: boolean;
};

export const WhatsNewButton = ({ introducerId, disabled = false }: TProps) => {
  const { width } = useWindowDimensions();
  const [showPopup, setShowPopup] = useState(false);
  const whatsNewPopupCookie = getCookie('whatsNewPopupClosed');

  const { numberUnread, data: notifications } = useWhatsNew({
    containerRef: {} as any,
    introducerId,
    fetchDataOnly: true,
    enabled: !disabled,
  });

  const notificationToDisplay = notifications[0];

  const handleClosePopup = () => {
    setCookie('whatsNewPopupClosed', notificationToDisplay?.id.toString());
    setShowPopup(false);
  };

  useEffect(() => {
    const hasNotClosedPopup =
      !whatsNewPopupCookie ||
      whatsNewPopupCookie !== notificationToDisplay?.id.toString();

    if (
      notificationToDisplay &&
      hasNotClosedPopup &&
      width >= BREAK_M &&
      numberUnread > 0 &&
      !disabled
    ) {
      setShowPopup(true);
    } else {
      setShowPopup(false);
    }
  }, [
    whatsNewPopupCookie,
    notificationToDisplay,
    width,
    numberUnread,
    disabled,
  ]);

  return (
    <>
      <div className={clsx(navigationStyles.navItem, styles.navItem)}>
        {!disabled && <Indicator numberUnread={numberUnread} />}
        <NavItemLink
          className={styles.navItemInner}
          href={PATH_NAMES.whatsNew()}
          label={t`What's new`}
          disabled={disabled}
        />
        {showPopup && (
          <Popup
            notification={notificationToDisplay}
            onCloseClick={handleClosePopup}
          />
        )}
      </div>
    </>
  );
};
